import FeaturesContainer from './FeaturesContainer'

const PunicButton = ({ history }) => {
    return <FeaturesContainer history={history} pageName={'panic-button'} nextUrl={'platform-support'} pageEvent={'onboardingSos'} clickEvent={'onboardingSosSubmitted'} />
};

export default PunicButton
